// extracted by mini-css-extract-plugin
module.exports = {"errorMessageWrapper":"JopPortalManagePermission_errorMessageWrapper__2A4Z3"};